import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CreateSupportTicketResponse,
  SupportTicket,
  SupportTicketMessage,
  SupportTicketRequest,
} from '../../shared/interfaces';
import { API_BASE_URL } from '../../shared/api/api.tokens';
import { REQUIRE_AUTH } from '../../shared/interceptors/auth-context';

@Injectable({ providedIn: 'root' })
export class SupportService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  private get ticketsUrl() {
    return `${this.baseUrl}/api/v1/support/tickets`;
  }

  private get authContext() {
    return { context: new HttpContext().set(REQUIRE_AUTH, true) };
  }

  listTickets(): Observable<SupportTicket[]> {
    return this.http.get<SupportTicket[]>(this.ticketsUrl, this.authContext);
  }

  createTicket(payload: SupportTicketRequest): Observable<CreateSupportTicketResponse> {
    return this.http.post<CreateSupportTicketResponse>(this.ticketsUrl, payload, this.authContext);
  }

  updateTicket(ticketId: string, payload: SupportTicketRequest): Observable<{ message: string }> {
    return this.http.put<{ message: string }>(`${this.ticketsUrl}/${ticketId}`, payload, this.authContext);
  }

  changeStatus(ticketId: string, status: 'open' | 'closed'): Observable<{ message: string }> {
    return this.http.put<{ message: string }>(
      `${this.ticketsUrl}/${ticketId}/status`,
      { status },
      this.authContext
    );
  }

  listMessages(ticketId: string): Observable<SupportTicketMessage[]> {
    return this.http.get<SupportTicketMessage[]>(`${this.ticketsUrl}/${ticketId}/messages`, this.authContext);
  }

  addMessage(ticketId: string, body: string): Observable<{ id: string }> {
    return this.http.post<{ id: string }>(`${this.ticketsUrl}/${ticketId}/messages`, { body }, this.authContext);
  }

  deleteTicket(ticketId: string): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.ticketsUrl}/${ticketId}`, this.authContext);
  }
}
